import InfoTaskHeader from './InfoTaskHeader';

export default InfoTaskHeader;
